require('./angular-cookies');
module.exports = 'ngCookies';



/*****************
 ** WEBPACK FOOTER
 ** ./~/angular-cookies/index.js
 ** module id = 29
 ** module chunks = 0
 **/